module.exports = "/_next/static/files/b9b41220159a2c8234718e879eaeaab7.svg";